var _mask, _path, _line, _line2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgressIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1_617",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0245 21.8341C14.0245 21.0748 14.4953 20.4059 15.1598 20.0386C18.4039 18.2457 20.6109 14.7117 20.6109 10.6453C20.6109 4.76551 15.9967 -0.000976562 10.3049 -0.000976562C4.61314 -0.000976562 -0.000976562 4.76551 -0.000976562 10.6453C-0.000976562 14.6009 2.08741 18.0527 5.18734 19.8883C5.85458 20.2833 6.32454 20.9703 6.32454 21.7458C6.32454 22.8199 7.19532 23.6907 8.26947 23.6907H12.1679C13.1933 23.6907 14.0245 22.8595 14.0245 21.8341Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18734 19.8883L5.95159 18.5975L5.18734 19.8883ZM15.1598 20.0386L14.4342 18.7258L15.1598 20.0386ZM19.1109 10.6453C19.1109 14.1615 17.2043 17.1948 14.4342 18.7258L15.8853 21.3515C19.6035 19.2965 22.1109 15.262 22.1109 10.6453H19.1109ZM10.3049 1.49902C15.1228 1.49902 19.1109 5.54763 19.1109 10.6453H22.1109C22.1109 3.98339 16.8707 -1.50098 10.3049 -1.50098V1.49902ZM1.49902 10.6453C1.49902 5.54763 5.48713 1.49902 10.3049 1.49902V-1.50098C3.73915 -1.50098 -1.50098 3.98339 -1.50098 10.6453H1.49902ZM5.95159 18.5975C3.30297 17.0293 1.49902 14.0654 1.49902 10.6453H-1.50098C-1.50098 15.1364 0.871843 19.0762 4.42309 21.179L5.95159 18.5975ZM12.1679 22.1907H8.26947V25.1907H12.1679V22.1907ZM4.82454 21.7458C4.82454 23.6484 6.36689 25.1907 8.26947 25.1907V22.1907C8.02375 22.1907 7.82454 21.9915 7.82454 21.7458H4.82454ZM4.42309 21.179C4.72744 21.3592 4.82454 21.6003 4.82454 21.7458H7.82454C7.82454 20.3403 6.98173 19.2075 5.95159 18.5975L4.42309 21.179ZM12.1679 25.1907C14.0217 25.1907 15.5245 23.6879 15.5245 21.8341H12.5245C12.5245 22.031 12.3649 22.1907 12.1679 22.1907V25.1907ZM14.4342 18.7258C13.3859 19.3052 12.5245 20.4293 12.5245 21.8341H15.5245C15.5245 21.7204 15.6046 21.5066 15.8853 21.3515L14.4342 18.7258Z",
    fill: "#7C7C7C",
    mask: "url(#path-1-inside-1_1_617)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.77441,
    y1: 25.0957,
    x2: 12.5744,
    y2: 25.0957,
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.47461,
    y1: 27.249,
    x2: 11.8746,
    y2: 27.249,
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.573 9.68808C14.2089 9.10303 9.90676 9.4587 10.2655 14.9323C12.3277 15.7487 16.2071 15.7169 16.573 9.68808Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47611 7.43717C5.84018 6.85212 10.6247 7.12548 10.2659 12.5991C8.20374 13.4155 3.84197 13.4659 3.47611 7.43717Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 22.399L10.2656 14.9324",
    stroke: "#7C7C7C",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIcon1);
export default __webpack_public_path__ + "static/media/progressIcon1.25474d64b62cf5ab0235e05ad9d03702.svg";
export { ForwardRef as ReactComponent };